import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-category",
  "use": "icon-category-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-category\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 2v5H2V2zM6 3H3v3h3zm8-1v5H9V2zm-1 1h-3v3h3zM7 14V9H2v5zm-4-4h3v3H3zm11-1v5H9V9zm-1 1h-3v3h3z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol